import { Injectable, signal } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PendingRequestsService {
  private destroy$ = new Subject<void>();
  private activeSubscriptions = signal<number>(0);

  get TakeUntilDestroy() {
    return this.destroy$.asObservable();
  }

  addSubscription(): void {
    this.activeSubscriptions.update(count => count + 1);
  }

  removeSubscription(): void {
    this.activeSubscriptions.update(count => Math.max(0, count - 1));
  }

  cancelAll(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.activeSubscriptions.set(0);
  }

  reset(): void {
    this.destroy$ = new Subject<void>();
  }

  get pendingCount(): number {
    return this.activeSubscriptions();
  }
}
